import { type ToastOptions as ReactToastOptions, toast as reactToast } from "react-toastify";
import { Toast, type ToastProps } from "./Toast";

export type ToastParams = {
	variant?: ToastProps["variant"];
	title: string;
	description?: ToastProps["description"];
	action?: ToastProps["action"];
	autoClose?: ReactToastOptions["autoClose"];
	role?: "alert" | "status";
};

export const toast = ({ variant = "success", title, description, action, autoClose, role = "alert" }: ToastParams) => {
	reactToast(
		({ closeToast }) => (
			<Toast variant={variant} title={title} description={description} action={action} closeToast={closeToast} />
		),
		{
			autoClose,
			role,
		},
	);
};
